import type { SVGProps } from 'react';

interface LogoPiece3IconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const LogoPiece3Icon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & LogoPiece3IconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 78 62"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g fill="#4FA9FF" opacity={0.3}>
      <path d="M7.153 68.569C2.627 61.609 0 53.3 0 44.376a44.4 44.4 0 0 1 2.913-15.868c1.448.452 2.93.913 4.396 1.365 6.72 2.08 11.618 1.923 13.396 4.559.84 1.235.416 11.379 0 21.2-.347 8.187-2.35 8.9-9.217 11.345a138 138 0 0 0-4.335 1.6zM83.85 64.077a44.47 44.47 0 0 1-18.98 19.54c-.025-1.201-.12-2.376-.337-3.463-.182-.93-.373-1.818-.555-2.653-.876-4.089-1.483-6.925-.087-8.143 1.682-1.47 9.572-5.394 14.462-7.238 2.098-.792 3.91.209 5.488 1.957zM71.58 9.525c10.267 8.126 16.856 20.714 16.856 34.85 0 3.063-.312 6.047-.893 8.926-6.642 4.724-15.485 9.622-18.789 10.927-4.907 1.931-4.812.078-4.5-5.455.027-.54.061-1.122.087-1.74.13-2.818.2-6.35.174-11.422.485-7.134.32-10.779.98-13.328.676-2.584 1.543-7.246 3.311-13.25 1.232-4.157 2.333-7.898 2.775-9.508M67.317 6.533c-.208.174-.424.357-.659.54-4.153 3.306-17.323 12.5-19.716 12.5s-5.99-.86-9.286-8.577c-1.092-2.549-2.765-5.663-4.422-8.743-.138-.252-.277-.513-.416-.765A44.3 44.3 0 0 1 44.202 0C52.673 0 60.581 2.384 67.3 6.525zM4.44 24.967c4.838-9.97 13.292-17.842 23.644-21.914 1.249 3.637 2.957 6.577 4.483 9.196 1.517 2.61 2.852 4.906 3.381 7.272 1.067 4.785-9.641 10.544-12.242 11.258-1.231.339-2.775-.41-4.847-1.419-2.298-1.113-5.254-2.548-9.164-3.166-1.57-.252-3.373-.687-5.246-1.235zM60.276 53.136c.616 6.96 1.162 13.093-3.789 14.493-5.02 1.418-12.545 1.096-16.933 0-.528-.13-1.144-.278-1.812-.443-4.907-1.183-12.927-3.106-13.395-5.377-1.101-5.341-.312-11.63.624-17.912.945-6.29 1.257-7.699 2.74-8.647.763-.479 3.217-3.054 5.774-5.724 2.454-2.567 4.994-5.229 6.226-6.238 1.43-1.174 5.254.835 9.173 2.897l8.072 3.41c2.636 1.114 3.346 8.595 3.216 15.764-.052 2.818-.095 5.498.078 7.49l.026.278zM63.726 25.766c1.144-2.949 5.705-15.11 2.93-14.284C63.891 12.3 47.122 23.044 50.8 24.27c.65.218 4.786 1.653 5.505 1.923 3.347 1.252 6.477 2.01 7.422-.418z" />
    </g>
  </svg>
);
